/* This file contains the user preferences which can be sourced from the API at later point */
export const PAGINATION_LIMIT = 10;